import React from 'react';

const CreateAccountPage = () => {
  return (
    <div>
      <h1 className="section_label">Create a new Account</h1>
    </div>
  );
};

export default CreateAccountPage;



// WEBPACK FOOTER //
// ./src/components/CreateAccountPage.js